import { useEffect, useState } from "react";
import fetchWithTimeout from "../utils/fetchWithTimeout.js";
import analytics from "../analytics/analytics.js";
const useGetSurveyContent = (submitChatMessagesPayload)=>{
    const [encodedId, setEncodedId] = useState('');
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isDetailsRetrieved, setIsDetailsRetrieved] = useState(false);
    const { hotelPayload, carPayload, flightPayload, packagePayload } = submitChatMessagesPayload;
    const mergedPayload = {
        ...hotelPayload,
        ...carPayload,
        ...flightPayload,
        ...packagePayload
    };
    useEffect(()=>{
        const fetchLink = async (offerNumber)=>{
            const url = `/genai-svc/genai/survey/details/${offerNumber}`;
            const response = await fetchWithTimeout(url, {
                method: 'GET'
            });
            if (response.ok) {
                const result = await response.json();
                setDetails(result?.details ?? []);
                setEncodedId(result?.encodedId ?? '');
                setIsDetailsRetrieved(result?.isDetailsRetrieved ?? false);
            }
            setLoading(false);
        };
        const offerNumber = mergedPayload?.offerNumber;
        if (offerNumber) fetchLink(offerNumber).catch((e)=>analytics.log({
                message: e.message,
                source: 'useGetSurveyLink'
            }));
    }, []);
    return {
        details,
        encodedId,
        isDetailsRetrieved,
        loading
    };
};
const hooks_useGetSurveyContent = useGetSurveyContent;
export { hooks_useGetSurveyContent as default };
